import { TerraSelectBoxValueInterface } from '../../forms/select-box/data/terra-select-box.interface';

/** @deprecated since v5.0. Please use mat-paginator instead */
export const terraPagerDefaultPagingSizes: Array<TerraSelectBoxValueInterface> = [
    {
        value: 25,
        caption: '25'
    },
    {
        value: 50,
        caption: '50'
    },
    {
        value: 75,
        caption: '75'
    },
    {
        value: 100,
        caption: '100'
    }
];
